import { Dialog } from '@angular/cdk/dialog';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeAT from '@angular/common/locales/de-AT';
import { Component, DestroyRef, inject, isDevMode, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { environment } from '../environments/environment';
import { commonModules } from './common_modules';
import { RecaptchaService } from './core/services/recaptcha.service';
import { RouterService } from './core/services/router.service';
import { SessionExpirationPollingService } from './core/services/session.expiration.polling.service';
import { SwUpdateService } from './core/services/sw.update.service';
import { CmsService } from './core/store/cms/cms.service';
import { CookieConsentStore } from './core/store/cookie-consent/cookie-consent.store';
import { ImportantMessageService } from './shared/building-blocks/important-message/important-message.service';
import { SnackbarService } from './shared/building-blocks/snackbar/snackbar.service';
import { CookieConsentDialogComponent } from './shared/dialog/cookie-consent-dialog/cookie-consent-dialog.component';

@Component({
  selector:    'app-root',
  templateUrl: './app.component.html',
  styleUrl:    './app.component.scss',
  imports:     [
    ...commonModules
  ],
  providers:   [
    RouterService,
    SnackbarService
  ]
})
export class AppComponent implements OnInit {

  cookieStore = inject(CookieConsentStore);
  cmsService = inject(CmsService);
  destroyRef = inject(DestroyRef);
  private recaptchaService = inject(RecaptchaService);
  importantMessageService = inject(ImportantMessageService);
  dialog = inject(Dialog);
  sessionExpirationPollingService = inject(SessionExpirationPollingService);
  swUpdateService = inject(SwUpdateService);

  constructor() {
    registerLocaleData(localeDeAT);
    registerLocaleData(localeDe);
    if (isDevMode()) {
      console.log('App is running in mode: ' + environment.env);
    }
  }

  ngOnInit() {
    this.recaptchaService.load(environment.reCaptchaSiteKeyV3);
    if (!this.cookieStore.currentSettings() || !this.cookieStore.currentSettings().cookieDialogShown) {
      this.dialog.open(CookieConsentDialogComponent)
        .closed
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe();
    }

    this.swUpdateService.setupServiceWorker();
    this.sessionExpirationPollingService.init(this.destroyRef);
    this.cmsService.loadCmsContent();
    this.cmsService.loadCmsStatusmeldung();
  }
}
